import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { MessageCircle, Send, History, Settings, Book, LogOut, Menu, X, Users, Webhook, Server } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isSuperAdmin = user.role === 'superadmin';

  const navigation = [
    { name: 'Home', path: '/dashboard', icon: MessageCircle, show: true },
    { name: 'Pesan', path: '/send', icon: Send, show: true },
    { name: 'Riwayat', path: '/history', icon: History, show: true },
    { name: 'Webhook', path: '/webhook-logs', icon: Webhook, show: true },
    // { name: 'Docs', path: '/background', icon: Server, show: true },
    { name: 'API Docs', path: '/api-docs', icon: Book, show: true },
    { name: 'Settings', path: '/settings', icon: Settings, show: true },
    { name: 'User', path: '/users', icon: Users, show: isSuperAdmin },
  ].filter(item => item.show);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    toast.success('Logout berhasil');
    navigate('/auth');
  };

  return (
    <div className="min-h-screen">
      {/* Navigation */}
      <nav className="glass-effect sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex items-center space-x-2">
              <MessageCircle className="text-green-600" size={32} />
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-xl font-bold text-gray-800">WhatsApp Manager</span>
                  {/* {!isSuperAdmin && (
                    <Badge className="bg-purple-600 text-xs">AMDIN</Badge>
                  )}
                  {isSuperAdmin && (
                    <Badge className="bg-purple-600 text-xs">AMDIN</Badge>
                  )} */}
                </div>
                {/* <p className="text-xs text-gray-500">{user.name}</p> */}
              </div>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-1">
              {navigation.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.name}
                    to={item.path}
                    data-testid={`nav-${item.name.toLowerCase().replace(' ', '-')}`}
                    className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all ${
                      isActive
                        ? 'bg-green-600 text-white'
                        : 'text-gray-700 hover:bg-green-50'
                    }`}
                  >
                    <Icon size={18} />
                    <span className="font-medium">{item.name}</span>
                  </Link>
                );
              })}
              <Button
                onClick={handleLogout}
                data-testid="logout-button"
                variant="outline"
                className="ml-2 border-red-300 text-red-600 hover:bg-red-50"
              >
                <LogOut size={18} className="mr-2" />
                Logout
              </Button>
            </div>

            {/* Mobile menu button */}
            <button
              data-testid="mobile-menu-toggle"
              className="md:hidden p-2 rounded-lg hover:bg-green-50"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <div className="md:hidden pb-4">
              {navigation.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.name}
                    to={item.path}
                    data-testid={`mobile-nav-${item.name.toLowerCase().replace(' ', '-')}`}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`flex items-center space-x-2 px-4 py-3 rounded-lg mb-1 transition-all ${
                      isActive
                        ? 'bg-green-600 text-white'
                        : 'text-gray-700 hover:bg-green-50'
                    }`}
                  >
                    <Icon size={20} />
                    <span className="font-medium">{item.name}</span>
                  </Link>
                );
              })}
              <button
                onClick={() => {
                  setMobileMenuOpen(false);
                  handleLogout();
                }}
                className="flex items-center space-x-2 px-4 py-3 rounded-lg w-full text-red-600 hover:bg-red-50"
              >
                <LogOut size={20} />
                <span className="font-medium">Logout</span>
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
